export default "__VITE_ASSET__Bvv5mmG0__"